"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["children"];
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Div = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  flex-direction: ", ";\n"])), function (_ref) {
  var flex = _ref.flex;
  return flex;
}, function (_ref2) {
  var wrap = _ref2.wrap;
  return wrap;
}, function (_ref3) {
  var justifyContent = _ref3.justifyContent;
  return justifyContent;
}, function (_ref4) {
  var alignItems = _ref4.alignItems;
  return alignItems;
}, function (_ref5) {
  var direction = _ref5.direction;
  return direction;
});
var Flex = function Flex(_ref6) {
  var children = _ref6.children,
    props = _objectWithoutProperties(_ref6, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Div, props, children);
};
Flex.propTypes = {
  justifyContent: (0, _propTypes.oneOf)(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly']),
  alignItems: (0, _propTypes.oneOf)(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  wrap: (0, _propTypes.oneOf)(['nowrap', 'wrap', 'wrap-reverse']),
  direction: (0, _propTypes.oneOf)(['row', 'row-reverse', 'column', 'column-reverse'])
};
var _default = exports["default"] = Flex;


//////////////////
// WEBPACK FOOTER
// ./node_modules/abihome-components/build/components/Flex/index.js
// module id = 172
// module chunks = 17